import React, { useContext, useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Form, Table, Pagination, Offcanvas, Button } from 'react-bootstrap'
import { FaPlus } from "react-icons/fa";
import APIServicenew from "../../utils/APIGeneralService";
import { UserContext } from "../../context/UserContextProvider";
import Paginator from "../../components/common/Pagination";
import Notauthorized from "../../components/Not-authorized/notauthorized";
import useMenuPermissions from "../../components/CustomHook/custompermission";
import { ToastContainer, toast } from "react-toastify";
import DeleteModal from "../../components/common/DeleteModel";
import RmFilter from "./RmFilter";

const RmList = () => {
    const [show, setShow] = useState(false);
    const [rmList,setRmList] = useState([])
    const [count,setCount]=useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [showDt, setShowDt] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [showFilter, setShowFilter] = useState(false);
    const [filters, setFilters] = useState({});
    const navigate = useNavigate();
    const limit = 10;
    const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
    const authToken = process.env.REACT_APP_authToken;
    const { accessToken,logout } = useContext(UserContext);
    const headers = { "auth-token": authToken, authorization: accessToken };
    const permissionscontext = useMenuPermissions('/admin/rm-list');

    useEffect(() => {
        fetchRmList(currentPage, filters);
      }, [currentPage, filters]);


    const fetchRmList = async (page = 1, filters) => {
        const params = {
            ...filters,
            offset: (page - 1) * limit,
            limit: limit,
          };
    
          const queryString = Object.entries(params)
            .filter(
              ([_, value]) => value !== "" && value !== undefined && value !== null
            )
            .map(([key, value]) => `${key}=${value}`)
            .join("&");
        try {
          const response = await APIServices.get(
            `/admin/relationship_manager/list?${queryString}`,
            headers
          );
          if (response?.status === 200) {
            const roleList = response?.data?.list || [];
            setRmList(roleList);
            setCount(response?.data?.count)
            const totalItems = response?.data?.count || 0;
            setTotalCount(Math.ceil(totalItems / limit));
          } else if(response?.status === 401){
            logout();
            navigate("/");
           }else {
            setRmList([]);
            setTotalCount(0);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
          setRmList([]);
          setTotalCount(0);
        }
      };

    const handleStatusChange = async (rm) => {
    const newStatus = rm.status === "Active" ? "Inactive" : "Active";
    try {
        const payload = { id: rm.id, status: newStatus };
        const res = await APIServices.post(
        `/admin/relationship_manager/status_update`,
        payload,
        headers
        );
        if (res?.data?.status === true) {
        showToast(res?.data?.message || "Success", "success");
        const updatedFaqs = rmList.map((item) =>
            item.id === rm.id ? { ...item, status: newStatus } : item
        );
        setRmList(updatedFaqs);
        } else {
        showToast(res?.data?.message || "Something went wrong.", "error");
        }
    } catch (error) {
        console.error("Error updating status:", error);
        showToast("Error updating status", "error");
    }
    };
    
    const handleDeleteRm = async () => {
        try {
          if (selectedUser !== null) {
            const payload = { id: selectedUser };
            const res = await APIServices.post(
              `/admin/relationship_manager/delete`,
              payload,
              headers
            );
            if (res?.data?.status === true) {
              showToast(res?.data?.message || "Success", "success");
              const updatedFaqs = rmList.filter((faq) => faq.id !== selectedUser);
              setRmList(updatedFaqs);
              setSelectedUser(null);
            } else {
              showToast(res?.data?.message || "Something went wrong.", "error");
            }
          }
          setShowDt(false);
        } catch (error) {
          console.error("Error deleting FAQ:", error);
        }
      };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const showToast = (message, type) => {
        toast(message, {
          position: "top-right",
          autoClose: 2000,
          type,
          hideProgressBar: false,
          closeOnClick: true,
        });
      };
    return (
      <>
        {permissionscontext.view ? (
          <>
            <div className="momList_inner todo_list_inner cp_list_inner ">
              <div className="mom_header d-flex align-items-center justify-content-between mb-3">
                <h1 className="font_blue_18 font-600">{`Relationship Managers (${count})`}</h1>

                <ul className="d-flex align-items-center mom_filter">
                  <li
                    className="d-flex align-items-center cursor-pointer"
                    onClick={() => setShowFilter(true)}
                  >
                    Filter By{" "}
                    <img
                      src="/images/Sort.svg"
                      className="img-fluid ms-2"
                      alt="Sort"
                    />
                  </li>
                  <li>
                    <button
                      className="btn red_button d-flex align-items-center"
                      onClick={() => navigate("/admin/add-rm")}
                      disabled={!permissionscontext.add}
                    >
                      <FaPlus className="me-1" />
                      Add RM
                    </button>
                  </li>
                </ul>
              </div>

              <div className="todoList_table">
                <div className="table-responsive">
                  <Table>
                    <thead className="table-dark">
                      <tr>
                        <th>Sr.No</th>
                        <th>Name</th>
                        <th>Region</th>
                        <th>State</th>
                        <th>Type</th>
                        <th>Channel Partner Name</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    {rmList && rmList?.length > 0 ? (
                    <>
                    <tbody>
                      {rmList.map((user, index) => (
                        <tr key={user.id}>
                          <td>{(currentPage - 1) * limit + index + 1}</td>
                          <td
                            onClick={() =>
                              navigate(`/admin/rm-details/${user.id}`)
                            }
                          >
                            <Link to="/ManagerDetails">
                              <div className="d-flex align-items-center">
                               {
                               user?.profile_pic ? 
                                <img
                                  src={user.profile_pic}
                                  className="img-fluid me-2 table_user"
                                  alt={user.first_name}
                                  onError={(e) => (e.target.src = "/images/placeholder-img.jpg")}
                                />
                              :
                                <img src="/images/placeholder-img.jpg"
                                className='img-fluid me-2 table_user' 
                                alt="default img" 
                                />
                              }
                                <p className="textTransform">{`${user?.first_name} ${user?.last_name}`}</p>
                              </div>
                            </Link>
                          </td>
                          <td>{user.region_name}</td>
                          <td>{user.state_name}</td>
                          <td>{user.relationship_manager_type ? user.relationship_manager_type : "N/A"}</td>
                          <td className="textTransform">{user.channel_partner_name}</td>
                          <td>
                            <Form className="Switch_toggle">
                              <input
                                type="checkbox"
                                checked={user.status === "Active"}
                                onClick={() => handleStatusChange(user)}
                                disabled={!permissionscontext.edit}
                                id={`switch-${user.id}`}
                              />
                              <label
                                htmlFor={`switch-${user.id}`}
                                className="position-relative"
                              >
                                Toggle
                              </label>
                            </Form>
                          </td>

                          <td>
                            <ul className="d-flex align-items-center justify-content-end gap-2">
                              <li>
                                <button
                                  disabled={!permissionscontext.delete}
                                  style={{
                                    border: "none",
                                    background: "transparent",
                                    padding: 0,
                                    cursor: !permissionscontext.delete
                                      ? "not-allowed"
                                      : "pointer",
                                    opacity: !permissionscontext.delete
                                      ? 0.5
                                      : 1,
                                  }}
                                  onClick={() => {
                                    setSelectedUser(user.id);
                                    setShowDt(true);
                                  }}
                                >
                                  <img
                                    src="/images/Trash.svg"
                                    className={`img-fluid trash ${
                                      !permissionscontext.delete
                                        ? "opacity-50 disabled"
                                        : ""
                                    }`}
                                    alt="trash"
                                  />
                                </button>
                              </li>
                              <li>
                                <button
                                  disabled={!permissionscontext.edit}
                                  style={{
                                    border: "none",
                                    background: "transparent",
                                    padding: 0,
                                    cursor: !permissionscontext.edit
                                      ? "not-allowed"
                                      : "pointer",
                                    opacity: !permissionscontext.edit ? 0.5 : 1,
                                  }}
                                  onClick={() =>
                                    navigate(`/admin/update-rm/${user.id}`, {
                                      state: { row: user },
                                    })
                                  }
                                >
                                  <img
                                    src="/images/Pen.svg"
                                    className={`img-fluid pen ${
                                      !permissionscontext.edit
                                        ? "opacity-50 disabled"
                                        : ""
                                    }`}
                                    alt="pen"
                                  />
                                </button>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    </>
                    ) : (
                      <>
                        <tbody>
                          <tr>
                            <td colSpan="6" className="border-0">
                              <div className="d-flex align-items-center justify-content-center mt-5">
                                <h4>Not Available</h4>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </>
                    )}
                  </Table>
                </div>
              </div>
              { count > 10 && (
              <Paginator
                currentPage={currentPage}
                totalPages={totalCount}
                onPageChange={handlePageChange}
              />
              )}
            </div>

            {showFilter && (
              <RmFilter
                appliedFilters={filters}
                show={showFilter}
                onHide={() => setShowFilter(false)}
                onApplyFilter={(filterData) => {
                  setFilters(filterData);
                  setShowFilter(false);
                }}
                onClear={() => {
                  setFilters({});
                  setShowFilter(false);
                }}
              />
            )}
            <DeleteModal
              showdt={showDt}
              handleCloseDt={() => setShowDt(false)}
              handledelete={handleDeleteRm}
            />
            <ToastContainer />
          </>
        ) : (
          <Notauthorized />
        )}
      </>
    );
}

export default RmList